
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const handleLogoClick = () => {
    navigate(user ? "/home" : "/");
  };
  
  return (
    <div className="flex flex-col min-h-screen">
      {/* Header */}
      <header className="border-b py-4 px-4 md:px-8 bg-background w-full">
        <div className="container mx-auto flex justify-between items-center">
          <div 
            className="flex items-center gap-2 cursor-pointer" 
            onClick={handleLogoClick}
          >
            <div className="w-8 h-8 rounded-full bg-primary flex items-center justify-center">
              <span className="text-primary-foreground font-bold">C</span>
            </div>
            <span className="text-xl font-semibold">Chito</span>
          </div>
          <nav className="flex items-center gap-4">
            <button 
              onClick={() => navigate("/")} 
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              Back to Home
            </button>
          </nav>
        </div>
      </header>
      
      {/* Main content */}
      <main className="flex-1">
        {children}
      </main>
      
      {/* Footer */}
      <footer className="py-6 px-4 md:px-8 border-t">
        <div className="container mx-auto flex flex-col md:flex-row justify-between items-center">
          <div 
            className="flex items-center gap-2 cursor-pointer mb-4 md:mb-0" 
            onClick={handleLogoClick}
          >
            <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center">
              <span className="text-primary-foreground font-bold text-xs">C</span>
            </div>
            <span className="text-sm font-semibold">Chito</span>
          </div>
          <div className="flex gap-6">
            <a href="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Terms</a>
            <a href="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Privacy</a>
            <a href="/refund" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Refund</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AuthLayout;
